import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const failures = ['Las cremas comerciales están diseñadas para durar años en una estantería, no para ser eficaces en tu dermis.', 'Los tratamientos de spa son un lujo temporal que no te enseñan a cuidar tu piel a diario.', 'Muchos productos "naturales" de supermercado siguen conteniendo rellenos que irritan las pieles sensibles.', 'La falta de un método claro te hace mezclar ingredientes al azar, sin entender el equilibrio del pH.'];
  return <section className="py-24 px-4 bg-botanical-ivory-dark" data-id="element-154">
      <div className="max-w-3xl mx-auto" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-16 text-center" data-id="element-156">
          <p className="text-xl md:text-2xl font-playfair italic text-botanical-forest leading-relaxed mb-8" data-id="element-157">
            Hay un momento frente al espejo en el que te preguntas: "¿Qué estoy
            aplicando realmente en mi piel?". Miras las etiquetas de tus cremas
            costosas y solo ves ingredientes impronunciables, promesas vacías y
            envases de plástico.
          </p>
          <p className="text-lg text-botanical-forest/80 font-lora" data-id="element-158">
            Sentir tu piel áspera, opaca o cansada no es falta de presupuesto;
            es falta de una verdadera conexión con la naturaleza. Tu piel no
            necesita más químicos, necesita alquimia.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-16" data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-playfair text-botanical-forest mb-6 text-center" data-id="element-160">
            El Círculo Vicioso de la Cosmética
          </h2>
          <p className="text-lg text-botanical-forest/80 font-lora leading-relaxed mb-6" data-id="element-161">
            Llevamos años saturando nuestros poros con siliconas, fragancias
            sintéticas y conservantes que "sellan" la piel pero no la nutren. El
            resultado es un círculo vicioso: piel que se siente seca apenas te
            lavas la cara, poros obstruidos y una opacidad que intentas cubrir
            con más maquillaje.
          </p>
          <p className="text-lg text-botanical-forest/80 font-lora leading-relaxed" data-id="element-162">
            Has probado exfoliantes que arden, tónicos que resecan y sueros que
            prometen milagros pero solo dejan tu rostro pegajoso.{' '}
            <strong className="font-medium text-botanical-forest" data-id="element-163">
              Es hora de dejar de adivinar y empezar a formular.
            </strong>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white p-8 md:p-12 rounded-sm shadow-sm border border-botanical-sage/20" data-id="element-164">
          <h3 className="text-2xl font-playfair text-botanical-terracotta mb-8 text-center" data-id="element-165">
            Por qué lo que has intentado no funcionó
          </h3>
          <ul className="space-y-6" data-id="element-166">
            {failures.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-167">
                <div className="mt-1 bg-botanical-terracotta/10 p-1 rounded-full shrink-0" data-id="element-168">
                  <X size={16} className="text-botanical-terracotta" data-id="element-169" />
                </div>
                <span className="text-botanical-forest/80 font-lora text-lg" data-id="element-170">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}